(function () {
  'use strict';


  function hydrateImage(image) {
    if (!image) return;

    var dataSrc = image.getAttribute('data-src');
    var dataSrcset = image.getAttribute('data-srcset');

    if (dataSrc && !image.getAttribute('src')) {
      image.setAttribute('src', dataSrc);
    }

    if (dataSrcset && !image.getAttribute('srcset')) {
      image.setAttribute('srcset', dataSrcset);
    }

    image.loading = 'eager';
    image.decoding = 'async';
    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
  }

  function preloadSlide(slide) {
    if (!slide) return;

    slide.querySelectorAll('img').forEach(hydrateImage);
    slide.querySelectorAll('source').forEach(function (source) {
      var dataSrcset = source.getAttribute('data-srcset');
      if (dataSrcset && !source.getAttribute('srcset')) {
        source.setAttribute('srcset', dataSrcset);
      }
    });
  }

  function preloadAround(gallery, index) {
    if (!gallery) return;

    var slides = Array.prototype.filter.call(
      gallery.querySelectorAll('.productView-image'),
      function (slide) {
        return !slide.classList.contains('slick-cloned');
      }
    );

    if (!slides.length) return;

    var current = Math.max(0, Math.min(index, slides.length - 1));
    preloadSlide(slides[current]);
    preloadSlide(slides[(current + 1) % slides.length]);
    if (current > 0) preloadSlide(slides[current - 1]);
  }

  function prepareGallery(gallery) {
    if (!gallery || gallery.dataset.reventV23Ready === 'true') return;

    gallery.dataset.reventV23Ready = 'true';
    // The first gallery image is already eager in Liquid. Fetch adjacent slides
    // only when the customer interacts with the gallery.

    var wrapper = gallery.closest('[data-image-gallery]') || gallery.parentElement;
    if (!wrapper) return;

    wrapper.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.productView-thumbnail');
      if (thumbnail) {
        var thumbnails = Array.prototype.filter.call(
          wrapper.querySelectorAll('.productView-thumbnail'),
          function (item) {
            return !item.classList.contains('slick-cloned');
          }
        );
        preloadAround(gallery, Math.max(0, thumbnails.indexOf(thumbnail)));
        return;
      }

      var nextArrow = event.target.closest('.slick-next');
      var previousArrow = event.target.closest('.slick-prev');
      if (!nextArrow && !previousArrow) return;

      var currentSlide = gallery.querySelector('.productView-image.slick-current');
      var currentIndex = currentSlide
        ? parseInt(currentSlide.getAttribute('data-index'), 10) - 1
        : 0;

      preloadAround(gallery, currentIndex + (nextArrow ? 1 : -1));
    }, true);

    if (window.jQuery) {
      window.jQuery(gallery).on('beforeChange.reventV23', function (_event, _slick, _current, next) {
        preloadAround(gallery, next);
      });
    }
  }

  function prepareGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-image-gallery-main]').forEach(prepareGallery);
  }


  function hydrateCardImage(image) {
    if (!image) return;

    var dataSrc = image.getAttribute('data-src');
    var dataSrcset = image.getAttribute('data-srcset');

    if (dataSrcset && !image.getAttribute('srcset')) {
      image.setAttribute('srcset', dataSrcset);
    }

    if (dataSrc && !image.getAttribute('src')) {
      image.setAttribute('src', dataSrc);
    }

    if (!image.getAttribute('src') && image.getAttribute('srcset')) {
      var firstCandidate = image.getAttribute('srcset').split(',')[0].trim().split(/\s+/)[0];
      if (firstCandidate) image.setAttribute('src', firstCandidate);
    }

    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
    image.loading = 'lazy';
    image.decoding = 'async';
  }

  function hydrateRecommendationImages(root) {
    var scope = root || document;

    scope.querySelectorAll(
      '.halo-recommendations-block .card-media img, ' +
      '.product-recommendations-loading .card-media img, ' +
      '[data-recommendations-block] .card-media img'
    ).forEach(hydrateCardImage);
  }

  function prepareRecommendationBlocks(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-recommendations-block]').forEach(function (block) {
      hydrateRecommendationImages(block);

      if (block.dataset.reventV25Observed === 'true') return;
      block.dataset.reventV25Observed = 'true';

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return;

            if (node.matches && node.matches('.card-media img')) {
              hydrateCardImage(node);
            }

            if (node.querySelectorAll) {
              node.querySelectorAll('.card-media img').forEach(hydrateCardImage);
            }
          });
        });
      });

      observer.observe(block, { childList: true, subtree: true });
    });
  }

  function prepareCoupons(root) {
    // Handled client-side by assets/revent-v27.js for instant dynamic pricing without full-page reloads
  }

  function init(root) {
    // Keep the server-rendered regional business-day policy; calendar-date
    // estimates cannot account for fulfilment cutoffs or regional holidays.

    prepareGalleries(root);
    prepareRecommendationBlocks(root);
    hydrateRecommendationImages(root);
    prepareCoupons(root);
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-revent-copy-code]');
    if (!button) return;
    var status = button.closest('.revent-product-offer')?.querySelector('[data-revent-copy-status]');
    var action = button.querySelector('.revent-product-offer__action');
    var originalAction = action?.textContent;
    try {
      await navigator.clipboard.writeText(button.dataset.reventCopyCode);
      button.classList.add('is-copied');
      if (action) action.textContent = button.dataset.copiedAction || 'Copied';
      if (status) status.textContent = button.dataset.copiedLabel || 'Code copied';
      window.setTimeout(function () {
        button.classList.remove('is-copied');
        if (action) action.textContent = originalAction;
        if (status) status.textContent = '';
      }, 2500);
    } catch (error) {
      if (status) status.textContent = button.dataset.copyError || 'Select and copy the code manually';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

(function () {
  'use strict';

  function updateStickyOffset() {
    var offset = 18;
    document.querySelectorAll(
      '.section-header-single-line, .section-header-navigation, .header-mobile, .announcement-bar'
    ).forEach(function (element) {
      var style = window.getComputedStyle(element);
      if (style.position === 'fixed' || style.position === 'sticky') {
        offset += element.getBoundingClientRect().height;
      }
    });
    document.documentElement.style.setProperty('--revent-product-sticky-offset', offset + 'px');
  }

  function currencyClass() {
    return window.location.hostname === 'ksa.revent.store' ? 'rev-sar' : 'rev-aed';
  }

  function formatAmount(cents) {
    var amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-AE', {
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function updateTotal(productView) {
    if (!productView) return;

    var input = productView.querySelector('.productView-details input.quantity__input');
    var total = productView.querySelector('[data-revent-live-total]');
    if (!input || !total) return;

    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    var price = parseInt(input.dataset.price, 10) || 0;
    var value = total.querySelector('[data-revent-total-value]');
    var quantityValue = total.querySelector('[data-revent-total-quantity]');
    var hasCoupon = total.classList.contains('has-coupon');

    if (quantity > 1 || hasCoupon) {
      total.style.display = 'flex';
    } else {
      total.style.display = 'none';
    }

    if (quantityValue) quantityValue.textContent = String(quantity);
    if (value && !hasCoupon) {
      value.innerHTML = '<span class="' + currencyClass() + '">' +
        formatAmount(price * quantity) + '</span>';
    }
  }

  function prepareTotal(productView) {
    if (!productView || productView.dataset.reventTotalReady === 'true') return;

    var input = productView.querySelector('.productView-details input.quantity__input');
    var actionRow = productView.querySelector('.productView-details .pvGroup-row');
    if (!input || !actionRow) return;

    productView.dataset.reventTotalReady = 'true';

    var total = document.createElement('div');
    total.className = 'revent-live-total';
    total.setAttribute('data-revent-live-total', '');
    total.style.display = 'none';
    total.innerHTML =
      '<span class="revent-live-total__label">Total for ' +
        '<strong data-revent-total-quantity>1</strong> item<span aria-hidden="true">:</span>' +
      '</span>' +
      '<strong class="revent-live-total__value" data-revent-total-value></strong>';

    actionRow.insertAdjacentElement('afterend', total);
    updateTotal(productView);

    input.addEventListener('input', function () {
      updateTotal(productView);
    });
    input.addEventListener('change', function () {
      updateTotal(productView);
    });

    actionRow.addEventListener('click', function (event) {
      if (!event.target.closest('.btn-quantity')) return;
      window.requestAnimationFrame(function () {
        updateTotal(productView);
      });
    });

    productView.addEventListener('revent:variant-changed', function () {
      window.requestAnimationFrame(function () {
        updateTotal(productView);
      });
    });
  }

  function hydrateDynamicImage(image) {
    if (!image || image.dataset.reventHydrated === 'true') return;

    var src = image.getAttribute('src');
    var dataSrc = image.getAttribute('data-src');
    var srcset = image.getAttribute('srcset');
    var dataSrcset = image.getAttribute('data-srcset');

    if ((!src || src === 'data:,' || src.indexOf('blank') !== -1) && dataSrc) {
      image.setAttribute('src', dataSrc);
    }
    if (!srcset && dataSrcset) {
      image.setAttribute('srcset', dataSrcset);
    }
    if (!image.getAttribute('src') && image.getAttribute('srcset')) {
      image.setAttribute('src', image.getAttribute('srcset').split(',')[0].trim().split(/\s+/)[0]);
    }

    image.loading = 'lazy';
    image.decoding = 'async';
    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
    image.dataset.reventHydrated = 'true';
  }

  function prepareDynamicCards(root) {
    var scope = root || document;
    scope.querySelectorAll(
      '.halo-recently-viewed-block .card-media img,' +
      '.halo-recommendations-block .card-media img,' +
      '[data-recommendations-block] .card-media img'
    ).forEach(hydrateDynamicImage);
  }

  function initConditionGuide(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-revent-condition-guide]').forEach(function(guide) {
      if (guide.dataset.initialized === 'true') return;
      guide.dataset.initialized = 'true';

      var tabs = guide.querySelectorAll('.revent-condition-tab');
      var panels = guide.querySelectorAll('.revent-condition-panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-condition-target');
          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function(p) {
            if (p.id === 'cond-' + target) {
              p.classList.add('is-active');
              p.removeAttribute('hidden');
            } else {
              p.classList.remove('is-active');
              p.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  }

  function initInspectionModal() {
    var modal = document.getElementById('revent-inspection-modal');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-inspection-modal]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });

    modal.querySelectorAll('[data-close-inspection-modal]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initGradeGuideTrigger(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-open-grade-guide]').forEach(function(btn) {
      if (btn.dataset.initialized === 'true') return;
      btn.dataset.initialized = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var accordion = document.querySelector('.revent-accordion-item');
        if (accordion) {
          accordion.open = true;
          accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
          accordion.classList.add('revent-accordion-item--highlight');
          setTimeout(function() {
            accordion.classList.remove('revent-accordion-item--highlight');
          }, 2400);
        }
      });
    });
  }

  function stabilizeGallery() {
    try {
      if (typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.slick) {
        var $ = window.jQuery;
        var $nav = $('.template-product .productView-nav');
        if ($nav.length && $nav.hasClass('slick-initialized')) {
          $nav.slick('setPosition');
        }
        var $for = $('.template-product .productView-for');
        if ($for.length && $for.hasClass('slick-initialized')) {
          $for.slick('setPosition');
        }
      }
    } catch (e) {}
  }

  function init(root) {
    var scope = root || document;
    updateStickyOffset();
    scope.querySelectorAll('.template-product .productView').forEach(prepareTotal);
    prepareDynamicCards(scope);
    initConditionGuide(scope);
    initGradeGuideTrigger(scope);
    initInspectionModal();
    stabilizeGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  window.addEventListener('load', function () {
    stabilizeGallery();
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', function () {
    updateStickyOffset();
    stabilizeGallery();
  }, { passive: true });
})();
